/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e={isAlongLine:0,isAbsoluteSize:1,isDiscrete:2};export{e as bitset};
